<script setup lang="ts">
import { TransitionFadeOut } from '@collector/shared-ui'
import { injectHasChangeSides } from '@desktop/views/Relation/Sports/provide-inject'

import ChangeSidesButton from './ChangeSidesButton.vue'
import QueueDisplayedIncident from './QueueDisplayedIncident/QueueDisplayedIncident.vue'
import QueueStatusIcon from './QueueDisplayedIncident/QueueStatusIcon.vue'
import { useLastDisplayedIncident } from './QueueDisplayedIncident/useLastDisplayedIncident'
import QueueErrorStatusIndicator from './QueueErrorStatusIndicator.vue'

interface Props {
  withQueueBlockedText?: boolean
}

withDefaults(defineProps<Props>(), {
  withQueueBlockedText: false,
})

// composables
const { lastDisplayedIncident, status } = useLastDisplayedIncident()

// inject
const changeSides = injectHasChangeSides()
</script>

<template>
  <!-- TODO: class needs refinement (remove unnecessary, also inside <QueueDisplayedIncident/> )-->
  <div class="flex w-full items-center gap-x-1 @sm:gap-x-2">
    <div class="min-w-60">
      <TransitionFadeOut>
        <QueueDisplayedIncident
          v-if="lastDisplayedIncident && status"
          :incident="lastDisplayedIncident"
        >
          <QueueStatusIcon :status />
        </QueueDisplayedIncident>
      </TransitionFadeOut>
    </div>
    <div class="ml-auto flex gap-x-1 @sm:gap-x-2">
      <QueueErrorStatusIndicator :withQueueBlockedText />
      <ChangeSidesButton v-if="changeSides" />
    </div>
  </div>
</template>
